module.exports = __webpack_public_path__ + "img/Remi.af66f04e.png";